module.exports = __webpack_public_path__ + "static/1-83b0c58328b44869cd06ecaa8dc5b391.jpg";